import React from 'react';

const Clock: React.FC = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.9997 29.3333C21.8907 29.3333 26.6663 24.5577 26.6663 18.6667C26.6663 12.7756 21.8907 8 15.9997 8C10.1086 8 5.33301 12.7756 5.33301 18.6667C5.33301 24.5577 10.1086 29.3333 15.9997 29.3333Z"
        fill="#2F88FF"
        stroke="black"
        strokeWidth="3.33333"
      />
      <path
        d="M18.6663 2.6665H13.333"
        stroke="black"
        strokeWidth="3.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 2.6665V7.99984"
        stroke="black"
        strokeWidth="3.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.333 10.6665L25.333 8.6665"
        stroke="black"
        strokeWidth="3.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 18.6665V14.6665"
        stroke="white"
        strokeWidth="3.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 18.6665H12"
        stroke="white"
        strokeWidth="3.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Clock;
